let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cN9ym")).then(() => parcelRequire('fzVPZ'));